/* The empty state for a workspace with no reporting period. Tokens only (ADR-0007).
 *
 * It is an `EmptyState` (icon, headline, one sentence, one action) and adds only the small info control
 * beside the action, which holds the reasons nothing is shown instead of a total.
 */

.card {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
